import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { findWhere } from 'underscore'
import moment from 'moment'

import JoinCampButton from './HeaderParts/JoinCampButton'
import Users from './HeaderParts/HeaderPart-Users'

import { joinCamp, leaveCamp } from '~/actions/camps'


export default class extends React.Component {
    static propTypes = {
		cover_banner: 		PropTypes.string,
		date: 				PropTypes.string.isRequired,
		description: 		PropTypes.string,
		editing: 			PropTypes.bool.isRequired,
		members: 			PropTypes.number,
		ID: 				PropTypes.number.isRequired,
		link: 				PropTypes.string.isRequired,
		location: 			PropTypes.string,
		owner: 				PropTypes.object.isRequired,
		sample_users: 		PropTypes.array,
		slug: 				PropTypes.string.isRequired,
		status: 			PropTypes.string,
		title: 				PropTypes.string.isRequired,
		total_posts: 		PropTypes.number,
		visibility: 		PropTypes.string.isRequired,
		toggleEditUsers: 	PropTypes.func.isRequired
	};

    render() {

		var {members, owner, sample_users} = this.props
		var {ID, status, editing, visibility} = this.props

		let style = this.props.cover_banner ? {backgroundImage: 'url(' + this.props.cover_banner + ')'} : {};

		return (
			<div className="container-fluid camp_banner mbot30" style={style}>

				<div className="text-dark-gray text-center ptop40 pbot40 pleft30 pright30 pbot80-xs bg-white bg-slightly-transparent">

					<h1 className="text-dark-gray mtop0 mbot30">{this.props.title}</h1>

					{ this.props.description && <p className="description mbot30">{this.props.description}</p> }

					<p className="small">
						{ 'Established ' + moment(this.props.date).format('MMMM YYYY') + ' | ' }
						{ this.props.members + ' Members | ' }
						{ this.props.total_posts + ' Posts' }
					</p>

					<div className="clearfix mbot30"></div>

					<Users 	members={members} 
							owner={owner}
							sample_users={sample_users} />

					<JoinCampButton ID={ID} status={status} editing={editing} visibility={visibility} toggleEditUsers={this.props.toggleEditUsers} />

				</div>

        	</div>
		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/CampParts/CampsPart-Header.jsx